import { useState } from "react";
import { User } from "lucide-react";

export default function ProfileImage({ imageUrl, className = '' }) {
    const [error, setError] = useState(false);

    if (!imageUrl || error) {
        return (
            <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
                <User className="w-4 h-4 text-gray-500" />
            </div>
        );
    }

    return (
        <img
            src={imageUrl}
            alt="Profile"
            className={`w-8 h-8 rounded-full object-cover inline-block ${className}`}
            onError={() => setError(true)}
        />
    );
}
